export default {
  API: "api.puntosgox.com",
  HTTP_API: "https:",
  PRODUCTION: false,

  SECTION_PRESENTATION_VIDEO: "https://youtu.be/PWNx313epuY",
  FACEBOOK_URL: "https://www.facebook.com/",
  INSTAGRAM_URL: "https://www.instagram.com/",
  LINKEDIN_URL: "https://www.linkedin.com/",
  YOUTUBE_URL: "https://www.youtube.com/",

  APP_STORE_URL: "https://play.google.com/store/games?hl=es",
  APPLE_STORE_URL: "https://www.apple.com/store",

  // URL de inicio de sesión para GOX Negocio
  GOX_NEGOCIOS_LOGIN_URL: "https://comercio.puntosgox.com/login",
};
